import {RequestBuilder} from '../request_builder'

export class SettingsRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'settings'
  }

  checkTfaEnabled () {
    this.segment = 'settings/tfa_any_enabled'
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/settings_request_builder.js